import { SEND_SMS, SEND_SMS_SUCCESS, SEND_SMS_FAILURE } from '../actions';

const initialState = {
    sending: undefined,
    sent: false,
    error: undefined,
    content: {},
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SEND_SMS:
            return {
                ...state,
                sending: true,
                sent: false,
                content: action.payload.content,
            };
        case SEND_SMS_SUCCESS:
            return {
                ...state,
                sending: false,
                sent: action.payload.content.sent,
                content: action.payload.content,
            };
        case SEND_SMS_FAILURE:
            return {
                ...state,
                sending: false,
                sent: 0,
            };
        default:
            return state;
    }
};

export default reducer;
